<template>
    <kgr-club-sales-list-config-data-provider
        :club-id="clubId"
        :callback="onClubSalesListConfigLoaded"
    >
        <template #default="clubSalesListConfigScope">
            <kgr-club-fee-category-data-provider
                :club-id="clubId"
                :callback="onClubFeeCategoriesLoaded"
            >
                <template #default="clubFeeCategoryScope">
                    <kgr-club-sales-list-item-data-provider
                        :club-id="clubId"
                        :callback="onClubSalesListItemsLoaded"
                    >
                        <template #default="clubSalesListItemsScope">
                            <kgr-form-scaffold
                                :pending="pending"
                                :with-back-button="false"
                                :save-button-disabled="saveButtonDisabled"
                                :with-primary-buttons="isEditable"
                                @primaryBtnClicked="update(clubSalesListConfigScope.reload, clubFeeCategoryScope.reload, clubSalesListItemsScope.reload)"
                            >
                                <kgr-club-sales-list-config-form
                                    :club-sales-list-config="clubSalesListConfig"
                                    :club-fee-categories="clubFeeCategories"
                                    :payment-methods="paymentMethods"
                                    :club-sales-list-items="clubSalesListItems"
                                    :is-editable="isEditable"
                                    :error="error"
                                />
                            </kgr-form-scaffold>
                        </template>
                    </kgr-club-sales-list-item-data-provider>
                </template>
            </kgr-club-fee-category-data-provider>
        </template>
    </kgr-club-sales-list-config-data-provider>
</template>

<script>
import ClubFeeCategoryDataProvider from '../../../components/data-provider/ClubFeeCategoryDataProvider';
import ClubSalesListConfigDataProvider from '../../../components/data-provider/ClubSalesListConfigDataProvider';
import ClubSalesListConfigForm from '../../../components/club/sales-list/ClubSalesListConfigForm';
import ClubSalesListConfigRepository from '../../../js/repository/ClubSalesListConfigRepository';
import ClubSalesListItemDataProvider from '../../../components/data-provider/ClubSalesListItemDataProvider';
import Error from '../../../js/model/Error';
import FormScaffold from '../../../components/common/form/FormScaffold';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-club-sales-list-config-data-provider': ClubSalesListConfigDataProvider,
        'kgr-club-sales-list-config-form': ClubSalesListConfigForm,
        'kgr-club-fee-category-data-provider': ClubFeeCategoryDataProvider,
        'kgr-club-sales-list-item-data-provider': ClubSalesListItemDataProvider,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        paymentMethods: {
            type: Array,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            pending: false,
            clubSalesListConfig: null,
            clubFeeCategories: null,
            clubSalesListItems: null,
        };
    },
    computed: {
        saveButtonDisabled() {
            return false;
        },
    },
    methods: {
        onClubSalesListConfigLoaded(clubSalesListConfig) {
            this.clubSalesListConfig = clubSalesListConfig;
        },
        onClubFeeCategoriesLoaded(loadedClubFeeCategories) {
            this.clubFeeCategories = loadedClubFeeCategories;
        },
        onClubSalesListItemsLoaded(loadedClubSalesListItems) {
            this.clubSalesListItems = loadedClubSalesListItems;
        },
        update(clubSalesListConfigReload, clubFeeCategoriesReload, clubSalesListItemsLoaded) {
            this.pending = true;
            ClubSalesListConfigRepository.update(this.clubId, this.clubSalesListConfig)
                .then(() => {
                    this.error = new Error();
                    clubSalesListConfigReload();
                    clubFeeCategoriesReload();
                    clubSalesListItemsLoaded();
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch(error => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
